import { toast } from 'react-toastify';

export const STATUS_COLORS = {
  draft: 'default',
  deploying: 'warning',
  deployed: 'success',
  failed: 'error',
};

export const STATUS_LABEL = {
  draft: 'Draft',
  deploying: 'Deploying…',
  deployed: 'On chain',
  failed: 'Failed',
};

export const truncateAddr = (a) => (a && a.length > 12 ? `${a.slice(0, 6)}…${a.slice(-4)}` : a || '');

const EXPLORERS = {
  1: 'https://etherscan.io/address/',
  11155111: 'https://sepolia.etherscan.io/address/',
  137: 'https://polygonscan.com/address/',
  80002: 'https://amoy.polygonscan.com/address/',
  8453: 'https://basescan.org/address/',
  84532: 'https://sepolia.basescan.org/address/',
};

export const blockExplorerUrl = (chainId, address) => {
  const base = EXPLORERS[chainId];
  if (!base || !address) return null;
  return `${base}${address}`;
};

export const copyToClipboard = (text) => {
  try {
    navigator.clipboard.writeText(text);
    toast.success('Copied');
  } catch (_) {
    toast.error('Copy failed');
  }
};
